import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import { getObjectValue, getValue } from '../../tools/util';
import Icon from '../../Icon';
import { defaultColumnRender, CUSTOM_ROW, CUSTOM_CELL } from '../common';
export var EXPANDED_ROW = Symbol('expandedRow');
export default function Expandable(_ref, _ref2) {
  var mapColumns = _ref.mapColumns,
      dataSource = _ref.dataSource,
      columns = _ref.columns,
      change = _ref.change;
  var expandable = _ref2.expandable;

  if (!expandable) {
    return {};
  }

  var expandableRowSet = new WeakSet();
  var _expandable$noIconCol = expandable.noIconColumn,
      noIconColumn = _expandable$noIconCol === void 0 ? false : _expandable$noIconCol,
      _expandable$expandedR = expandable.expandedRowRender,
      expandedRowRender = _expandable$expandedR === void 0 ? function () {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0");
  } : _expandable$expandedR,
      _expandable$rowExpand = expandable.rowExpandable,
      rowExpandable = _expandable$rowExpand === void 0 ? true : _expandable$rowExpand,
      _expandable$expandedS = expandable.expandedStateName,
      expandedStateName = _expandable$expandedS === void 0 ? 'expanded' : _expandable$expandedS,
      _expandable$fixed = expandable.fixed,
      fixed = _expandable$fixed === void 0 ? false : _expandable$fixed;
  var handledDataSource = [];
  var hasExpandableRow = false; // 计算展开后的dataSource

  dataSource.forEach(function (record) {
    handledDataSource.push(record);

    if (getValue(rowExpandable, record)) {
      expandableRowSet.add(record);
      hasExpandableRow = true; // 展开的行

      if (getObjectValue(record, expandedStateName)) {
        var _handledDataSource$pu;

        handledDataSource.push((_handledDataSource$pu = {}, _defineProperty(_handledDataSource$pu, CUSTOM_ROW, true), _defineProperty(_handledDataSource$pu, EXPANDED_ROW, expandedRowRender(record)), _handledDataSource$pu));
      }
    }
  });
  var columnsLength = columns.length; // 展开图标列

  var expandIconColumn = {
    className: 'jmtd-table-plugin-expandable',
    fitContent: true,
    affix: true,
    render: function render(_, record) {
      if (record[EXPANDED_ROW]) {
        return '';
      }

      return expandableRowSet.has(record) && /*#__PURE__*/React.createElement(Icon, {
        className: getObjectValue(record, expandedStateName) ? 'jmti-caret-up' : 'jmti-caret-right',
        onClick: function onClick() {
          change('expand', record);
        }
      });
    }
  }; // 处理后列渲染，使支持展开行

  var handledColumns = mapColumns(function (_ref3, columnIndex) {
    var _ref3$render = _ref3.render,
        _render = _ref3$render === void 0 ? defaultColumnRender : _ref3$render;

    return {
      render: function render(text, row) {
        // 在展开行时，仅第一列渲染，其他列为空
        var expendedContent = row[EXPANDED_ROW];

        if (expendedContent) {
          if (columnIndex === 0) {
            var _ref4;

            return _ref4 = {}, _defineProperty(_ref4, CUSTOM_CELL, true), _defineProperty(_ref4, "children", fixed ? /*#__PURE__*/React.createElement("div", {
              className: "jmtd-table-fixed-cell"
            }, expendedContent) : expendedContent), _defineProperty(_ref4, "className", 'jmtd-table-cell-no-padding'), _defineProperty(_ref4, "props", {
              'data-custom': true,
              colSpan: columnsLength
            }), _ref4;
          }

          return {
            empty: true
          };
        }

        for (var _len = arguments.length, arg = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          arg[_key - 2] = arguments[_key];
        }

        return _render.apply(void 0, [text, row].concat(arg));
      }
    };
  });
  return {
    dataSource: handledDataSource,
    rowClassName: function rowClassName(row) {
      return row[EXPANDED_ROW] ? 'jmtd-table-plugin-expandable-row' : null;
    },
    columns: [].concat(hasExpandableRow && !noIconColumn ? expandIconColumn : []).concat(handledColumns)
  };
}